import { useNavigate } from "react-router-dom";
import "./Footer.css";

export function Footer() {
  const openSocial = (socialLink: string) => {
    window.open(socialLink);
  };

  const handleClickScroll = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navigate = useNavigate();
  const handleNavigate = (route:string) => navigate(("/"+route));

  return (
    <>
      <div className="footer">
        <div className="screen-max flex">
          <div className="footer-inner">
            {/* Footer list */}
            <div className="footer-list">
              <div
                className="footer-list-item hover-target"
                onClick={() => {
                  handleClickScroll("home");
                  handleNavigate("");
                }}
              >
                Home
              </div>
              <div
                className="footer-list-item hover-target"
                onClick={() => {
                  handleClickScroll("about");
                  handleNavigate("");
                }}
              >
                About
              </div>
              <div
                className="footer-list-item hover-target"
                onClick={() => {
                  handleClickScroll("skills");
                  handleNavigate("");
                }}
              >
                Skills
              </div>
              <div
                className="footer-list-item hover-target"
                onClick={() => {
                  handleClickScroll("portfolio");
                  handleNavigate("portfolio");
                }}
              >
                Portfolio
              </div>
              <div
                className="footer-list-item hover-target"
                onClick={() => {
                  handleClickScroll("contact");
                  handleNavigate("");
                }}
              >
                Contact
              </div>
            </div>

            {/* Socials */}
            <div className="footer-socials flex-c">
              <div onClick={() => openSocial("https://github.com/YashShivhare007")}>
                <i className="fa-brands fa-2xl fa-github hover-target"></i>
              </div>
              <div
                onClick={() =>
                  openSocial("https://www.linkedin.com/in/yashshivhare007/")
                }
              >
                <i className="fa-brands fa-2xl fa-linkedin hover-target"></i>
              </div>
              <div onClick={() => openSocial("https://leetcode.com/u/shivhareyash007/")}>
                <i className="fa-solid fa-xl fa-code hover-target"></i>
              </div>
            </div>

            {/* Branding */}
            <div className="footer-brand">
              <div className="footer-brand-logo">
                <img
                  src={"/assets/transparent_logo.svg"}
                  alt="logo"
                />
              </div>
              <div className="footer-brand-text">
                2023 &copy; Yash Shivhare
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
